import { jsx as _jsx } from "react/jsx-runtime";
import { WorkspaceMfaRequirement } from '@lucidlink/dto/validation';
import { ButtonLink, Trans, translate, } from '@lucidlink/uicore';
export const getTwoFactorAuthenticationToast = ({ onButtonClick, toastId, workspaceData: { mfaRequirement, name }, }) => {
    const isMfaRequired = mfaRequirement === WorkspaceMfaRequirement.REQUIRED;
    return {
        'data-testid': toastId,
        id: toastId,
        kind: isMfaRequired ? 'negative' : 'informative',
        content: {
            message: translate(isMfaRequired
                ? 'Workspace {{name}} now requires 2FA authentication.'
                : 'Workspace {{name}} will require 2FA when you next log in.', {
                name,
            }),
        },
        dismissTempo: 'never',
        actionComponent: (_jsx(ButtonLink, { "data-testid": "toast-go-to-two-factor-authentication", kind: "ghost", onClick: onButtonClick, size: "big", to: "/account", children: _jsx(Trans, { children: "Set up now" }) })),
    };
};
